// @ts-nocheck
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useDifusiones } from "../../Difusiones/context/DifusionesContext";
import { useFormContext } from "react-hook-form";

export default function SelectArea({ area, setArea }) {
  const {
    listas,
    areasUser,
  } = useDifusiones();
  const form = useFormContext();

  const handleChange = (event) => {
    setArea(event.target.value);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl required fullWidth {...(form ? form.register("area") : {})}>
        <InputLabel id="select-area-label">Área</InputLabel>
        <Select
          labelId="select-area-label"
          id="select-area"
          value={area ?? ""}
          name="area"
          label="Area"
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>Seleccione un área</em>
          </MenuItem>
          {areasUser
            .filter((area) => area.id !== "ff73f6b1-6201-4193-81dc-ae35d7dbe235") // Filtro areaa "Grupo VPN" para PRD.
            .map((area) => (
              <MenuItem key={area.id} value={area.id}>
                {area.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}
